export default "__VITE_ASSET__BUbm0Etm__"